export default __webpack_public_path__ + "static/Home-480-835b55970866837319a16ec5a589070f.webp";